import script from "./VehicleTab.vue?vue&type=script&setup=true&name=BasicInfoTab&lang=js"
export * from "./VehicleTab.vue?vue&type=script&setup=true&name=BasicInfoTab&lang=js"

import "./VehicleTab.vue?vue&type=style&index=0&id=42801fb4&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-42801fb4"]])

export default __exports__